import { HolisticProjectTypes } from '@aims/shared/holistic-projects/constants';
import { Form, Select } from 'antd';
import React from 'react';
import SelectRegion from '../../shared/SelectRegion';

function SelectProjectType({ value, onChange, ...props }) {
  return (
    <Select
      placeholder="Select a Project Type"
      allowClear
      value={value}
      onChange={onChange}
      {...props}
    >
      {Object.values(HolisticProjectTypes).map((p) => (
        <Select.Option key={p.key} value={p.key}>
          {p.label}
        </Select.Option>
      ))}
    </Select>
  );
}

function HolisticProjectFilters({ form, onFiltersChanged }) {
  return (
    <div
      style={{
        maxWidth: 800,
        marginRight: 'auto',
        marginLeft: 'auto',
      }}
    >
      <Form layout="vertical" form={form} onValuesChange={onFiltersChanged}>
        <Form.Item name="regions" label="Select a Region">
          <SelectRegion filters={{}} mode="multiple" />
        </Form.Item>
        <Form.Item name="projectTypes" label="Select a Project Type">
          <SelectProjectType mode="multiple" />
        </Form.Item>
      </Form>
    </div>
  );
}

export default HolisticProjectFilters;
